export default __webpack_public_path__ + "static/media/nic.75d2dd19.jpg";